import { Link } from 'react-router-dom';

const articles = [
  {
    to: '/yoybuy-sheet-guide',
    title: 'Полное руководство по YOYbuy Sheet',
    desc: 'Как использовать таблицы для умного шоппинга из Китая',
    icon: 'ri-book-open-line',
  },
  {
    to: '/yoybuy-spreadsheet-shoes',
    title: 'Заказ обуви из Китая',
    desc: 'Кроссовки, кеды, ботинки — гид по размерам',
    icon: 'ri-footprint-line',
  },
  {
    to: '/yoybuy-spreadsheet-hoodies',
    title: 'Худи и свитеры',
    desc: 'Выбор ткани, размеры и проверка качества',
    icon: 'ri-t-shirt-line',
  },
  {
    to: '/yoybuy-spreadsheet-jackets',
    title: 'Куртки и верхняя одежда',
    desc: 'Пуховики, бомберы, косухи — всё об утеплителях',
    icon: 'ri-shirt-line',
  },
  {
    to: '/yoybuy-spreadsheet-bags',
    title: 'Сумки и рюкзаки',
    desc: 'Кожа, канвас, нейлон — материалы и качество',
    icon: 'ri-handbag-line',
  },
  {
    to: '/yoybuy-spreadsheet-accessories',
    title: 'Аксессуары',
    desc: 'Очки, часы, украшения, ремни — полный каталог',
    icon: 'ri-glasses-line',
  },
  {
    to: '/yoybuy-spreadsheet-safety',
    title: 'Безопасность покупок',
    desc: 'Защита данных, проверка продавцов, платёжная безопасность',
    icon: 'ri-shield-check-line',
  },
  {
    to: '/yoybuy-spreadsheet-shipping',
    title: 'Доставка из Китая',
    desc: 'Способы, сроки, стоимость — как сэкономить',
    icon: 'ri-ship-line',
  },
  {
    to: '/yoybuy-spreadsheet-vs-agents',
    title: 'Таблицы против агентов',
    desc: 'Сравнение подходов: что эффективнее',
    icon: 'ri-scales-line',
  },
  {
    to: '/yoybuy-spreadsheet-taobao',
    title: 'Заказ с Taobao',
    desc: 'Пошаговая инструкция поиска и оформления',
    icon: 'ri-shopping-bag-3-line',
  },
  {
    to: '/yoybuy-spreadsheet-sizes',
    title: 'Таблица размеров',
    desc: 'Конвертация и правильные измерения тела',
    icon: 'ri-ruler-line',
  },
];

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs md:text-sm font-label tracking-widest uppercase text-accent-600 mb-3">
              База знаний YOYbuy Sheet
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              Все статьи о шоппинге из Китая
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              Изучите наши подробные руководства, чтобы заказывать товары из Китая быстро, безопасно и без ошибок в размерах
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {articles.map((article) => (
              <Link
                key={article.to}
                to={article.to}
                className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
              >
                <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                  <i className={`${article.icon} text-lg text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 leading-relaxed">
                    {article.desc}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}